import { formatMoney } from '../../../shared/policies/format-money';
import type { ExpenseView } from '../expenses.api';

function receiptsLine(count: number): string {
  if (count === 0) return 'No receipt';
  return count === 1 ? '1 photo attached' : `${count} photos attached`;
}

/** The expense as the approver sees it before deciding. Photos are counted, not shown: there is no receipt download endpoint yet. */
export function ExpenseSummary({ expense }: { expense: ExpenseView }) {
  return (
    <dl className="mb-6 grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
      <dt className="text-muted">Driver</dt>
      <dd>{expense.driverName}</dd>
      <dt className="text-muted">For</dt>
      <dd>{expense.truckRegistration ? `Truck ${expense.truckRegistration}` : `Trip ${expense.tripNumber ?? ''}`.trim()}</dd>
      <dt className="text-muted">Category</dt>
      <dd>{expense.category.name}</dd>
      <dt className="text-muted">Amount</dt>
      <dd className="font-medium">{formatMoney(expense.amount)}</dd>
      <dt className="text-muted">Receipt</dt>
      <dd>{receiptsLine(expense.receipts.length)}</dd>
      {expense.note && (
        <>
          <dt className="text-muted">Note</dt>
          <dd>{expense.note}</dd>
        </>
      )}
    </dl>
  );
}
